import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTable, useGlobalFilter, useFilters, usePagination } from "react-table";
import { Row, Col, Button } from "react-bootstrap";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import "../components/table/FilteringTable/filtering.css";
import { ColumnFilter } from "../components/table/FilteringTable/ColumnFilter";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useDispatch } from "react-redux";
import { Fn_DeleteData, Fn_FillListData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import { toast } from "react-toastify";

export const PageList_EmployeeTypeMaster = () => {
  const [gridData, setGridData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const LIST_API_URL = `${API_WEB_URLS.MASTER}/0/token/EmployeeTypeMaster/Id/0`;
  const DELETE_API_URL = `${API_WEB_URLS.MASTER}/0/token/EmployeeTypeMaster`;

  const loadData = useCallback(() => {
    Fn_FillListData(dispatch, setGridData, "gridData", LIST_API_URL).catch((err) => {
      console.error("Failed to load employee types:", err);
    });
  }, [dispatch, LIST_API_URL]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const btnAddOnClick = () => navigate("/AddEmployeeType", { state: { Id: 0 } });
  const btnEditOnClick = (Id) => navigate("/AddEmployeeType", { state: { Id } });

  const handleDelete = (id, name) => {
    if (!id) return;
    if (window.confirm(`Are you sure you want to delete this employee type master${name ? ` (${name})` : ""}?`)) {
      Fn_DeleteData(dispatch, setGridData, Number(id), DELETE_API_URL, LIST_API_URL)
        .then(() => {
          toast.success("Employee Type deleted successfully");
          loadData();
        })
        .catch((error) => {
          console.error("Failed to delete employee type:", error);
        });
    }
  };

  const COLUMNS = [
    {
      Header: "Sr No.",
      accessor: (row, index) => index + 1,
      Cell: ({ row }) => row.index + 1,
      disableFilters: true,
    },
    {
      Header: "Employee Type Name",
      Footer: "Employee Type Name",
      accessor: "Name",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      accessor: (row) => (row.IsNotInUse !== undefined ? row.IsNotInUse : row.NotInUse),
      Filter: ColumnFilter,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "badge-danger" : "badge-success"}`}>
          {value ? "Not In Use" : "Active"}
        </span>
      ),
    },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div className="d-flex gap-1">
          <Button
            variant="primary"
            size="sm"
            onClick={() => btnEditOnClick(row.original.Id)}
            title="Edit Employee Type"
          >
            <i className="fa fa-edit"></i>
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => handleDelete(row.original.Id, row.original.Name)}
            title="Delete Employee Type"
          >
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
      disableFilters: true,
    },
  ];

  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => gridData, [gridData]);

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 } },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  return (
    <Container fluid className="page-content">
      <Row className="mb-3 align-items-center">
        <Col md="6">
          <h4 className="page-title mb-0" style={{ fontFamily: "Poppins" }}>
            <i className="fas fa-id-badge me-2" style={{ color: "#7c69ef" }}></i>
            Employee Type Master
          </h4>
        </Col>
        <Col md="6" className="text-end d-flex justify-content-end gap-2">
          <Button variant="success" size="sm" onClick={btnAddOnClick}>
            <i className="fas fa-plus me-1"></i> Add New
          </Button>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
              </div>

              <div className="table-responsive">
                <table {...getTableProps()} className="table table-bordered table-striped custom-table">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps()} key={column.id}>
                            {column.render("Header")}
                            <div>{column.canFilter ? column.render("Filter") : null}</div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.length > 0 ? (
                      page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()} key={row.id}>
                            {row.cells.map((cell) => (
                              <td {...cell.getCellProps()} key={cell.column.id}>
                                {cell.render("Cell")}
                              </td>
                            ))}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={columns.length} className="text-center py-4 text-muted">
                          No Employee Types Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {page.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    <span>
                      Page{" "}
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </span>
                  </div>
                  <div className="d-flex gap-1">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => gotoPage(0)}
                      disabled={!canPreviousPage}
                    >
                      {"<<"}
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => previousPage()}
                      disabled={!canPreviousPage}
                    >
                      Previous
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => nextPage()}
                      disabled={!canNextPage}
                    >
                      Next
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => gotoPage(pageOptions.length - 1)}
                      disabled={!canNextPage}
                    >
                      {">>"}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PageList_EmployeeTypeMaster;